import React from 'react';
import PropTypes from 'prop-types';
import {Content} from './Content';
import {Wrapper} from './Wrapper';
import {ContentWrap} from './ContentWrap';
import {Notebook} from '@learningblocks/storybook-components';

/**
 * MenuContentList:
 *  - To List the Chapter Menu and Their Content
 *    in the same view
 */
export function MenuContentList(props) {
  const onSelect = (sectionValue) => () => props.onSelect(sectionValue);

  const getClassName = (menu) => {
    return menu?.current ? 'chapter-active' : 'chapter';
  };

  const getContentVisible = (menu) => menu?.current;

  const renderContent = (menu, index) => {
    return (
      <ContentWrap className='tab-book_content--item' key={menu.value}>
        <Notebook.MobileChapterMenu
          {...menu}
          className={getClassName(menu)}
          onSelect={onSelect(menu.value)}
        />
        <Content
          goToNext={props.onSelect}
          components={props.components}
          currentMenu={props.currentMenu}
          visible={getContentVisible(menu)}
          nextMenuValue={props.nextMenuValue}
        />
      </ContentWrap>
    );
  };

  return (
    <Wrapper className='tab-book_content'>
      {props.menuList.map(renderContent)}
    </Wrapper>
  );
}

MenuContentList.propTypes = {
  /**
   * Callback fired when a Menu is Selected/Clicked
   */
  onSelect: PropTypes.func,
  /**
   * List of Menu to display
   */
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Title to display in  menu
       */
      title: PropTypes.string.isRequired,
      /**
       * Boolean specifying if menu is selected
       */
      current: PropTypes.bool.isRequired,
      /**
       * Index number of menu
       */
      number: PropTypes.number.isRequired,
      /**
       * Unique string value of the menu
       */
      value: PropTypes.string.isRequired,
      /**
       * Boolean set when section is visited
       */
      visited: PropTypes.bool.isRequired,
    })
  ),
  /**
   * Components in current section to be displayed in Notebook
   */
  components: PropTypes.arrayOf(PropTypes.object),
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * Value for next-in-line menu
   * NONE value mens no more next section
   */
  nextMenuValue: PropTypes.oneOf([
    'CONTEXT',
    'TECHNIQUES',
    'DESIGN',
    'PROBLEM_SOLVING',
    'RESULTS',
    'REFLECTION',
    'TROUBLESHOOTING',
    'NONE',
  ]),
};

MenuContentList.defaultProps = {};
